import {
  getMachinePreferencesFromUrl,
  setMachinePreferencesInLocalStorage,
} from 'features/machine-preferences/helpers';

export const useMachinePreferences = () => {
  const machinePreferences = getMachinePreferencesFromUrl();
  setMachinePreferencesInLocalStorage(machinePreferences);
};
